import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericHttp } from '@services/remote-api/generic-http.service';
import { Config } from '@config/config.service';
import { of as observableOf } from 'rxjs';
import { fetchAzureConfig } from 'app/azure-handler';
import { environment } from '@environments/environment';

@Injectable()
export class LoginApiService {
  private signinUrl: string;
  private signInAzureUrl: string;
  private changePasswordUrl: string;
  private resetUserPasswordUrl: string;

  constructor(
    private trbhttp: GenericHttp,
    private config: Config
  ) {
    this.signinUrl = config.signinUrl;
    this.signInAzureUrl = config.signInAzureUrl;
    this.changePasswordUrl = config.changePasswordUrl;
    this.resetUserPasswordUrl = config.resetUserPasswordUrl;
  }

  sendPasswordEmail(data: any): Observable<any> {
    return this.trbhttp.post(this.resetUserPasswordUrl, data);
  }

  changePassword(data: any): Observable<any> {
    return this.trbhttp.post(this.changePasswordUrl, data);
  }

  signin(params: any): Observable<any> {
    return this.trbhttp.post(this.signinUrl, params);
  }

  signInAzure(params: any): Observable<any> {
    return this.trbhttp.post(this.signInAzureUrl, {
      ...params,
      clientId: fetchAzureConfig().clientID,
    });
  }
}
